import {
    Box,
    Dialog
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { FunctionComponent, useEffect, useRef, useState } from 'react';

import { Label } from '../../../../shared';
import { dialogPaperProps } from '../../../NewWork/components/styled';
import { BlameIssuesTitle, CloseButton, DescriptionContent, DescriptionHeader, ReadMoreButton, S, TextWrapper } from './styled';

type Props = {
    open?: boolean;
    onClose?: () => void;
    description: string;
    issuesText: string | undefined;
    title: string;
};

// Reusable collapsible text section component
const CollapsibleText: FunctionComponent<{
    text: string;
    open: boolean;
}> = ({ text, open }) => {
    const [ expanded, setExpanded ] = useState(false);
    const [ showButton, setShowButton ] = useState(false);
    const textRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!open) {
            setExpanded(false);
            setShowButton(false);
            return;
        }

        const timer = setTimeout(() => {
            if (textRef.current) {
                const isClamped = textRef.current.scrollHeight > textRef.current.clientHeight;
                setShowButton(isClamped);
            }
        }, 100);

        return () => clearTimeout(timer);
    }, [ text, open ]);

    return (
        <TextWrapper>
            <DescriptionContent ref={textRef} expanded={expanded}>
                {text}
            </DescriptionContent>
            {showButton && (
                <ReadMoreButton onClick={() => setExpanded(!expanded)}>
                    {expanded ? 'Read less' : 'Read more'}
                </ReadMoreButton>
            )}
        </TextWrapper>
    );
};

const IssuesModal: FunctionComponent<Props> = ({
    open = false,
    onClose,
    description,
    issuesText,
    title
}: Props) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
            PaperProps={dialogPaperProps}
        >
            <Box display="flex" justifyContent="flex-end">
                <CloseButton onClick={onClose}>
                    <CloseIcon />
                </CloseButton>
            </Box>
            
            <Box mt={0}>
                <DescriptionHeader>
                    <Label sxOverrides={{ ...S.title, marginRight: '8px', paddingBottom: '0px' }}>
                        {title}
                    </Label>
                </DescriptionHeader>
                <Label sxOverrides={S.text}>
                    <CollapsibleText text={description} open={open} />
                </Label>
            </Box>

            <Box mt={2}>
                <Label sxOverrides={{ ...S.title }}>
                    <BlameIssuesTitle>
                        Issues
                    </BlameIssuesTitle>
                </Label>
                <Label sxOverrides={S.text}>
                    <CollapsibleText text={issuesText || 'No issues available.'} open={open} />
                </Label>
            </Box>

            <Box mt={2}>
                <Label sxOverrides={S.note}>
                    NOTE: you are not tasked to fix the problems mentioned in issues. You are expected to understand the issues and improve in future tasks.
                </Label>
            </Box>
        </Dialog>
    );
};

export default IssuesModal;
